import React, {
  useCallback,
} from 'react';
import {
  shallowEqual,
  useSelector,
} from 'react-redux';

import {
  coreSelectors,
} from '@gymcloud/core';

import {
  Flex,
  Text,
} from 'web-styled';

import {
  getPropertyValue,
  getConvertedUnitName,
} from 'web-utils';

import * as S from '../styled';

const formatPropertyTime = (time: number) => {
  const mind = time % (60 * 60);
  const minutes = Math.floor(mind / 60);

  const secd = mind % 60;
  const seconds = Math.ceil(secd);

  const m = minutes > 0 ? minutes : '00';
  const s = seconds > 0 ? seconds : '00';
  return `${m}:${s}`;
};

type Props = {
  exercise: any
  nextNumber: string,
};

const ExerciseResultListItem = ({ exercise, nextNumber }: Props) => {
  const mapState = useCallback(state => ({
    settings: coreSelectors.getProfile('user_settings')(state),
    properties: coreSelectors.getExerciseProperties(
      exercise.workout_exercise_id,
    )(state),
  }), [exercise.id]);

  const {
    settings,
    properties,
  } = useSelector(mapState, shallowEqual);

  return (
    <S.Item
      bottomLine={exercise.number === nextNumber}
      number={exercise.number}
    >
      <S.NumberContainer
        number={exercise.number}
      >
        {exercise.order_name}
      </S.NumberContainer>
      <S.ItemBody>
        <Text color="#5F5F5F" size="17px">
          {exercise.name}
        </Text>
        <Flex column width="100%" spacing={11}>
          {properties.map(p => {
            const pp = p.personal_property || {};
            const name = pp.name || 'No property type';

            if (!p.result?.value) {
              return (
                <Text key={p.id} color="#9E9E9E" size="12px">
                  {name}
                </Text>
              );
            }

            const concertedUnit = getConvertedUnitName(p.property_unit_name, settings.units_system);
            const isTime = (concertedUnit === 's' || concertedUnit === 'mmss');
            const value = isTime
              ? formatPropertyTime(p.result.value)
              : getPropertyValue(p.result, concertedUnit);

            return (
              <Flex
                key={p.id}
                justify="space-between"
                align="center"
                width="100%"
              >
                <Text color="#9E9E9E" size="12px">
                  {name}
                  {` (${concertedUnit})`}
                </Text>
                <Text color="#333333" size="15px" weight="bold">
                  {value}
                </Text>
              </Flex>
            );
          })}
        </Flex>
      </S.ItemBody>
    </S.Item>
  );
};

export default ExerciseResultListItem;
